import React, {useState} from "react";
import {Modal} from "react-bootstrap";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import classNames from "classnames";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons";
import {dateFormatter} from "../../../components/BootStrapTableCellFormatters";
import './SubscriptionHistoryModal.scss';

const SubscriptionHistoryModal = ({history, prices, onHide}) => {
    const [details, setDetails] = useState(null)
    const [page, setPage] = useState(1)
    const [sizePerPage, setSizePerPage] = useState(10)
    const [dropdownClosed, setDropdownClosed] = useState(false)

    const isEmpty = value => value === null || value === undefined || value === ''

    const formatValue = value => {
        if (isEmpty(value)) return '-'
        if (typeof value === 'boolean') return value ? 'Enabled' : 'Disabled'
        return prices[value] ? `${value} (${prices[value]})` : String(value)
    }

    const renderSizePerPageDropDown = (props) =>
        <div className={classNames('btn-group dropup', {closed: dropdownClosed})}
             onMouseLeave={() => setDropdownClosed(false)}>
            <button className="btn btn-info dropdown-toggle" type="button" data-toggle="dropdown">
                <span>{props.currSizePerPage}</span>
                <span className="ml-6 caret"></span>
            </button>
            <ul className="dropdown-menu">
                {props.sizePerPageList.map(item =>
                    <li key={item}>
                        <a className='table-pagination dropdown-item'
                           onClick={() => {
                               props.changeSizePerPage(item)
                               setDropdownClosed(true)
                           }}>{item}</a>
                    </li>
                )}
            </ul>
        </div>

    const renderTable = () =>
        <BootstrapTable
            data={history}
            key={page}
            striped
            bordered={false}
            hover
            height="auto"
            pagination
            options={{
                page,
                onPageChange: setPage,
                sizePerPage,
                sizePerPageList: [10, 25, 50],
                onSizePerPageList: setSizePerPage,
                sizePerPageDropDown: renderSizePerPageDropDown,
                onRowClick: (row) => Object.keys(row.details).length > 0 && setDetails(row)
            }}
        >
            <TableHeaderColumn hidden isKey dataField="id">Id</TableHeaderColumn>
            <TableHeaderColumn dataField="created_at" dataFormat={dateFormatter} width="30%">
                Date/Time
            </TableHeaderColumn>
            <TableHeaderColumn dataField="changed_by" width="30%" dataFormat={email =>
                <span className="user-email" title={email}>{email}</span>}>User</TableHeaderColumn>
            <TableHeaderColumn dataField="activity" width="40%">Activity</TableHeaderColumn>
        </BootstrapTable>

    const renderDetails = () => {
        const fields = Object.entries(details.details)

        return <div className="subscription-history-details">
            <div className="details-card">
                {fields.map(([field, value]) =>
                    <div className="detail" key={field}>
                        {fields.length > 1 && <p className="detail-field">{field.replace(/_/g, ' ')}</p>}
                        <div>
                            {Array.isArray(value) ?
                                <>
                                    {!isEmpty(value[0]) && <p><s>{formatValue(value[0])}</s></p>}
                                    <p>{formatValue(value[1])}</p>
                                </> :
                                <p>{formatValue(value)}</p>}
                        </div>
                    </div>
                )}
            </div>
        </div>
    }

    return (
        <Modal className="fontIOS subscription-history-modal" show onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>
                    {details ?
                        <>
                            <FontAwesomeIcon className="back-arrow" icon={faArrowLeft}
                                             onClick={() => setDetails(null)}/>
                            {details.activity}
                            <p>{dateFormatter(details.created_at)} · {details.changed_by}</p>
                        </> :
                        'Subscription history'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {details ? renderDetails() : renderTable()}
            </Modal.Body>
        </Modal>
    )
}

export default SubscriptionHistoryModal;
